// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const ClinicBanner = ({ data }) => {
//   const navigate = useNavigate();
//   if (!data) {
//     console.warn('ClinicBanner: data prop is undefined');
//     return null;
//   }
//   const { id, image, heading, body } = data;

//   return (
//     <section id={id} className="w-full py-6 px-4 md:px-8 ava-card-bg">
//       <div className="max-w-6xl mx-auto">
//         <div
//           className="relative w-full overflow-hidden rounded-xl"
//           style={{ minHeight: 'clamp(160px, 22vw, 240px)' }}
//         >
//           {/* <img
//             src={image}
//             alt={heading}
//             className="absolute inset-0 w-full h-full object-cover object-center"
//             draggable={false}
//           /> */}

//           <div
//             className="absolute inset-0 bg-white"
//           // style={{ backgroundColor: 'rgba(30, 50, 120, 0.62)' }}
//           />

//           <div className="relative z-10 w-full h-full flex items-center">
//             <div
//               className="px-8 md:px-12 py-8 md:py-10 flex flex-col gap-3"
//               style={{ maxWidth: '780px' }}
//             >
//               <h2
//                 className=" ava-heading-lg"
//                 style={{
//                   //  fontSize: 'clamp(1.3rem, 2.8vw, 2rem)'
//                 }}
//               >
//                 {heading}
//               </h2>
//               {body && (
//                 <p
//                   className="ava-text-body "
//                   style={{
//                     // fontSize: 'clamp(0.82rem, 1.4vw, 1rem)',
//                     opacity: 0.92,
//                   }}
//                 >
//                   {body}
//                 </p>
//               )}
//             </div>
            
//           </div>
//           <button className='btn-primary' onClick={() => navigate('/book-appointment')}>
//               Book an Appointment
//             </button>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default ClinicBanner;
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ClinicBanner = ({ data }) => {
  const navigate = useNavigate();

  if (!data) {
    console.warn('ClinicBanner: data prop is undefined');
    return null;
  }

  const { id, heading, body } = data;

  return (
    <section id={id} className="w-full py-6 px-4 md:px-8 ava-card-bg">
      <div className="max-w-6xl mx-auto">
        <div className="w-full bg-white rounded-xl flex flex-col md:flex-col items-start justify-between gap-6 px-8 md:px-12 py-8 md:py-10">
          
          {/* Left: heading + body */}
          <div className="flex flex-col gap-3" style={{ maxWidth: '780px' }}>
            <h2 className="ava-heading-lg">
              {heading}
            </h2>
            {body && (
              <p className="ava-text-body" style={{ opacity: 0.92 }}>
                {body}
              </p>
            )}
          </div>

          {/* Right: button */}
          <button
            className="btn-primary flex-shrink-0"
            onClick={() => navigate('/book-appointment')}
          >
            Book an Appointment
          </button>
        </div>
      </div>
    </section>
  );
};

export default ClinicBanner;